"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
exports.get = get;

var _Target = _interopRequireDefault(require("../events/Target.js"));

var _EventType = _interopRequireDefault(require("../events/EventType.js"));

var _ImageState = _interopRequireDefault(require("../ImageState.js"));

var _color = require("../color.js");

var _dom = require("../dom.js");

var _IconImageCache = require("./IconImageCache.js");

var _Image = require("../Image.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * @module ol/style/IconImage
 */
var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

/**
 * @type {CanvasRenderingContext2D}
 */
var taintedTestContext = null;

var IconImage =
/** @class */
function (_super) {
  __extends(IconImage, _super);
  /**
   * @param {HTMLImageElement|HTMLCanvasElement} image Image.
   * @param {string|undefined} src Src.
   * @param {import("../size.js").Size} size Size.
   * @param {?string} crossOrigin Cross origin.
   * @param {import("../ImageState.js").default} imageState Image state.
   * @param {import("../color.js").Color} color Color.
   */


  function IconImage(image, src, size, crossOrigin, imageState, color) {
    var _this = _super.call(this) || this;
    /**
     * @private
     * @type {HTMLImageElement|HTMLCanvasElement}
     */


    _this.hitDetectionImage_ = null;
    /**
     * @private
     * @type {HTMLImageElement|HTMLCanvasElement}
     */

    _this.image_ = !image ? new Image() : image;

    if (crossOrigin !== null) {
      /** @type {HTMLImageElement} */
      _this.image_.crossOrigin = crossOrigin;
    }
    /**
     * @private
     * @type {Object<number, HTMLCanvasElement>}
     */


    _this.canvas_ = {};
    /**
     * @private
     * @type {import("../color.js").Color}
     */

    _this.color_ = color;
    /**
     * @private
     * @type {?function():void}
     */

    _this.unlisten_ = null;
    /**
     * @private
     * @type {import("../ImageState.js").default}
     */

    _this.imageState_ = imageState;
    /**
     * @private
     * @type {import("../size.js").Size}
     */

    _this.size_ = size;
    /**
     * @private
     * @type {string|undefined}
     */

    _this.src_ = src;
    /**
     * @private
     */

    _this.tainted_;
    return _this;
  }
  /**
   * @private
   * @return {boolean} The image canvas is tainted.
   */


  IconImage.prototype.isTainted_ = function () {
    if (this.tainted_ === undefined && this.imageState_ === _ImageState["default"].LOADED) {
      if (!taintedTestContext) {
        taintedTestContext = (0, _dom.createCanvasContext2D)(1, 1);
      }

      taintedTestContext.drawImage(this.image_, 0, 0);

      try {
        taintedTestContext.getImageData(0, 0, 1, 1);
        this.tainted_ = false;
      } catch (e) {
        taintedTestContext = null;
        this.tainted_ = true;
      }
    }

    return this.tainted_ === true;
  };
  /**
   * @private
   */


  IconImage.prototype.dispatchChangeEvent_ = function () {
    this.dispatchEvent(_EventType["default"].CHANGE);
  };
  /**
   * @private
   */


  IconImage.prototype.handleImageError_ = function () {
    this.imageState_ = _ImageState["default"].ERROR;
    this.unlistenImage_();
    this.dispatchChangeEvent_();
  };
  /**
   * @private
   */


  IconImage.prototype.handleImageLoad_ = function () {
    this.imageState_ = _ImageState["default"].LOADED;

    if (this.size_) {
      this.image_.width = this.size_[0];
      this.image_.height = this.size_[1];
    } else {
      this.size_ = [this.image_.width, this.image_.height];
    }

    this.unlistenImage_();
    this.dispatchChangeEvent_();
  };
  /**
   * @param {number} pixelRatio Pixel ratio.
   * @return {HTMLImageElement|HTMLCanvasElement} Image or Canvas element.
   */


  IconImage.prototype.getImage = function (pixelRatio) {
    this.replaceColor_(pixelRatio);
    return this.canvas_[pixelRatio] ? this.canvas_[pixelRatio] : this.image_;
  };
  /**
   * @param {number} pixelRatio Pixel ratio.
   * @return {number} Image or Canvas element.
   */


  IconImage.prototype.getPixelRatio = function (pixelRatio) {
    this.replaceColor_(pixelRatio);
    return this.canvas_[pixelRatio] ? pixelRatio : 1;
  };
  /**
   * @return {import("../ImageState.js").default} Image state.
   */


  IconImage.prototype.getImageState = function () {
    return this.imageState_;
  };
  /**
   * @return {HTMLImageElement|HTMLCanvasElement} Image element.
   */


  IconImage.prototype.getHitDetectionImage = function () {
    if (!this.hitDetectionImage_) {
      if (this.isTainted_()) {
        var width = this.size_[0];
        var height = this.size_[1];
        var context = (0, _dom.createCanvasContext2D)(width, height);
        context.fillRect(0, 0, width, height);
        this.hitDetectionImage_ = context.canvas;
      } else {
        this.hitDetectionImage_ = this.image_;
      }
    }

    return this.hitDetectionImage_;
  };
  /**
   * Get the size of the icon (in pixels).
   * @return {import("../size.js").Size} Image size.
   */


  IconImage.prototype.getSize = function () {
    return this.size_;
  };
  /**
   * @return {string|undefined} Image src.
   */


  IconImage.prototype.getSrc = function () {
    return this.src_;
  };
  /**
   * Load not yet loaded URI.
   */


  IconImage.prototype.load = function () {
    if (this.imageState_ == _ImageState["default"].IDLE) {
      this.imageState_ = _ImageState["default"].LOADING;

      try {
        /** @type {HTMLImageElement} */
        this.image_.src = this.src_;
      } catch (e) {
        this.handleImageError_();
      }

      this.unlisten_ = (0, _Image.listenImage)(this.image_, this.handleImageLoad_.bind(this), this.handleImageError_.bind(this));
    }
  };
  /**
   * @param {number} pixelRatio Pixel ratio.
   * @private
   */


  IconImage.prototype.replaceColor_ = function (pixelRatio) {
    if (!this.color_ || this.canvas_[pixelRatio] || this.imageState_ !== _ImageState["default"].LOADED) {
      return;
    }

    var canvas = document.createElement('canvas');
    this.canvas_[pixelRatio] = canvas;
    canvas.width = Math.ceil(this.image_.width * pixelRatio);
    canvas.height = Math.ceil(this.image_.height * pixelRatio);
    var ctx = canvas.getContext('2d');
    ctx.scale(pixelRatio, pixelRatio);
    ctx.drawImage(this.image_, 0, 0);
    ctx.globalCompositeOperation = 'multiply'; // Internet Explorer 11 does not support the multiply operation.
    // If the canvas is tainted in Internet Explorer this still produces
    // a solid color image with the shape of the icon.

    if (ctx.globalCompositeOperation === 'multiply' || this.isTainted_()) {
      ctx.fillStyle = (0, _color.asString)(this.color_);
      ctx.fillRect(0, 0, canvas.width / pixelRatio, canvas.height / pixelRatio);
      ctx.globalCompositeOperation = 'destination-in';
      ctx.drawImage(this.image_, 0, 0);
    } else {
      var imgData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      var data = imgData.data;
      var r = this.color_[0] / 255.0;
      var g = this.color_[1] / 255.0;
      var b = this.color_[2] / 255.0;
      var a = this.color_[3];

      for (var i = 0, ii = data.length; i < ii; i += 4) {
        data[i] *= r;
        data[i + 1] *= g;
        data[i + 2] *= b;
        data[i + 3] *= a;
      }

      ctx.putImageData(imgData, 0, 0);
    }
  };
  /**
   * Discards event handlers which listen for load completion or errors.
   *
   * @private
   */


  IconImage.prototype.unlistenImage_ = function () {
    if (this.unlisten_) {
      this.unlisten_();
      this.unlisten_ = null;
    }
  };

  return IconImage;
}(_Target["default"]);
/**
 * @param {HTMLImageElement|HTMLCanvasElement} image Image.
 * @param {string} src Src.
 * @param {import("../size.js").Size} size Size.
 * @param {?string} crossOrigin Cross origin.
 * @param {import("../ImageState.js").default} imageState Image state.
 * @param {import("../color.js").Color} color Color.
 * @return {IconImage} Icon image.
 */


function get(image, src, size, crossOrigin, imageState, color) {
  var iconImage = _IconImageCache.shared.get(src, crossOrigin, color);

  if (!iconImage) {
    iconImage = new IconImage(image, src, size, crossOrigin, imageState, color);

    _IconImageCache.shared.set(src, crossOrigin, color, iconImage);
  }

  return iconImage;
}

var _default = IconImage;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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